export function parseLog(jsonLog: object, isCompact = false) {
	const message = { 'rmc-web-cx-web-blocks': jsonLog };

	return JSON.stringify(message, null, isCompact ? 0 : 2);
}
